/* RESPONSIBLE TEAM: team-ai-agent */
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export type FinAgentType = 'support' | 'sales';

const STORAGE_KEY = 'fin-agent-type-last-on-fin-route';

function readStored(): FinAgentType {
  if (typeof sessionStorage === 'undefined') {
    return 'support';
  }
  return sessionStorage.getItem(STORAGE_KEY) === 'sales' ? 'sales' : 'support';
}

function writeStored(value: FinAgentType) {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(STORAGE_KEY, value);
  }
}

export default class FinAgentTypeService extends Service {
  @tracked currentAgentType: FinAgentType = readStored();

  setCurrentAgentType(value: FinAgentType) {
    this.currentAgentType = value;
    writeStored(value);
  }
}
